import React, { useContext } from 'react'
import { Link, BaseIcon } from 'chemistry'
import { TranslateContext } from 'client/common/translator'
import { isPraxis } from 'common/utils'

const ShareSVG = props => (
  <BaseIcon width='20px' height='20px' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='none' {...props}>
    <circle cx='14.1667' cy='5' r='2' stroke='currentColor' />
    <circle cx='5.83325' cy='10' r='2' stroke='currentColor' />
    <circle cx='14.1667' cy='15' r='2' stroke='currentColor' />
    <path d='M12.0833 6.25L7.5 8.75' stroke='currentColor' strokeLinecap='round' />
    <path d='M12.0833 13.75L7.5 11.25' stroke='currentColor' strokeLinecap='round' />
  </BaseIcon>
)

export const ShareButton = ({ name, format }) => {
  const t = useContext(TranslateContext)
  const onClick = async e => {
    const shareUrl = window.location?.href?.replace(window.location?.search, '')
    if (!shareUrl) return

    const trackingSearchParams = new URLSearchParams({
      utm_source: isPraxis(format) ? 'praxis_app' : 'brico_app',
      utm_medium: 'copied-link',
      utm_campaign: 'product-share'
    }).toString()
    const title = name
    const text = `${shareUrl}?${trackingSearchParams}`

    try {
      if (navigator?.share) {
        await navigator.share({ title, text })
      } else if (window?.AndroidWebAppInterface?.shareProduct) {
        window.AndroidWebAppInterface.shareProduct(title, text)
      }
    } catch {}
  }
  return (
    <Link as='button' id='share-product-button' variant='iconLink' onClick={onClick} Icon={ShareSVG}>
      {t('share.button_name')}
    </Link>
  )
}
